var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQuestion = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill-stroke",
    width: 25.008,
    height: 25.008,
    viewBox: "0 0 25.008 25.008",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1836.719 -352.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1836.976 353)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill stroke",
    d: "M412,126.479a.479.479,0,1,0,.479-.479A.479.479,0,0,0,412,126.479Z",
    transform: "translate(-392.284 -119.97)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill stroke",
    d: "M433.6,164.82a9.118,9.118,0,0,1-.183,1.818.478.478,0,0,0,.373.565.47.47,0,0,0,.1.01.479.479,0,0,0,.468-.383,10.068,10.068,0,0,0,.2-2.01,9.94,9.94,0,0,0-.972-4.31.479.479,0,1,0-.864.412A8.992,8.992,0,0,1,433.6,164.82Z",
    transform: "translate(-411.965 -152.569)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill stroke",
    d: "M201.264,212.7h-.479v-6.221a.479.479,0,0,0-.479-.479h-3.828a.479.479,0,0,0-.479.479v1.914a.479.479,0,0,0,.479.479h.479V212.7h-.479a.479.479,0,0,0-.479.479v1.914a.478.478,0,0,0,.479.479h4.785a.479.479,0,0,0,.479-.479v-1.914A.479.479,0,0,0,201.264,212.7Zm-.479,1.914h-3.828v-.957h.479a.479.479,0,0,0,.479-.479v-4.785a.479.479,0,0,0-.479-.479h-.479v-.957h2.871v6.221a.479.479,0,0,0,.479.479h.479Z",
    transform: "translate(-186.621 -196.142)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill stroke",
    d: "M217.914,109.828A1.914,1.914,0,1,0,216,107.914,1.916,1.916,0,0,0,217.914,109.828Zm0-2.871a.957.957,0,1,1-.957.957A.958.958,0,0,1,217.914,106.957Z",
    transform: "translate(-205.663 -100.927)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill stroke",
    d: "M12.25,0A12.459,12.459,0,0,0,0,12.251a13.049,13.049,0,0,0,1.739,6.479L.024,23.872a.479.479,0,0,0,.605.605l5.142-1.714A13.046,13.046,0,0,0,12.25,24.5,12.458,12.458,0,0,0,24.5,12.251,12.458,12.458,0,0,0,12.25,0Zm0,23.544a11.969,11.969,0,0,1-6.162-1.711.478.478,0,0,0-.407-.05L1.235,23.266,2.717,18.82a.478.478,0,0,0-.05-.408A11.969,11.969,0,0,1,.957,12.251,11.445,11.445,0,0,1,12.25.957,11.445,11.445,0,0,1,23.544,12.251,11.445,11.445,0,0,1,12.25,23.544Z",
    transform: "translate(0.001)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question.bf10f39e.svg";
export { ForwardRef as ReactComponent };